import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import MiniButton from "../../components/MiniButton";
import { colorsList } from "../../data/colorsList";
import PrePin from "./PrePin";
import { isEditor } from "../../functions/isEditor";

export default function PositionScreen({
  board,
  beginRaster,
  continueRaster,
  finishRaster,
  pinAnimStep,
  startPinAnim,
  confirmPosition,
  pinAnim,
  resetPosition,
}) {
  const buttonStyle = (marginLeft) => {
    return {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: 20,
      marginLeft,
    };
  };
  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: board + "%",
        zIndex: 101,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          background: "radial-gradient(rgba(0,0,0,0), rgba(100,0,0,0.25))",
        }}
        onMouseDown={beginRaster}
        onMouseMove={continueRaster}
        onMouseUp={finishRaster}
        onTouchStart={beginRaster}
        onTouchMove={continueRaster}
        onTouchEnd={finishRaster}
      >
        <PrePin pinAnim={pinAnim} pinAnimStep={pinAnimStep} />
        {pinAnimStep === 0 && (
          <>
            <MiniButton
              Icon={CheckIcon}
              onClick={() => (!isEditor ? startPinAnim(0) : confirmPosition())}
              color={colorsList.green}
              iconSize={25}
              shadow={true}
              style={buttonStyle(-40)}
            />
            <MiniButton
              Icon={ClearIcon}
              onClick={resetPosition}
              color={colorsList.red}
              iconSize={25}
              shadow={true}
              style={buttonStyle(10)}
            />
          </>
        )}
      </div>
    </div>
  );
}
